<template>
  <div class="mouse-control">
    <div class="m-header">
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.4193 8.2526C17.4193 4.70878 14.5464 1.83594 11.0026 1.83594C7.45878 1.83594 4.58594 4.70878 4.58594 8.2526V13.7526C4.58594 17.2964 7.45878 20.1693 11.0026 20.1693C14.5464 20.1693 17.4193 17.2964 17.4193 13.7526V8.2526Z"
          stroke="#C7C7C7"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11 5.5V9.16667"
          stroke="#C7C7C7"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div class="m-title">Управление мышкой</div>
    </div>

    <div class="m-block" style="margin-top: 16px">
      <div>Перемещение</div>

      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 7.32031V10.0023"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 10V15C5 16.8565 5.7375 18.637 7.05025 19.9497C8.36301 21.2625 10.1435 22 12 22C13.8565 22 15.637 21.2625 16.9497 19.9497C18.2625 18.637 19 16.8565 19 15V9C19 5.473 16.392 2.485 13 2"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7 6C8.10457 6 9 5.10457 9 4C9 2.89543 8.10457 2 7 2C5.89543 2 5 2.89543 5 4C5 5.10457 5.89543 6 7 6Z"
          stroke="#008CFF"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <div class="m-block">
      <div>Поворот</div>

      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 7.32031V10.0023"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 10V15C19 16.8565 18.2625 18.637 16.9497 19.9497C15.637 21.2625 13.8565 22 12 22C10.1435 22 8.36301 21.2625 7.05025 19.9497C5.7375 18.637 5 16.8565 5 15V9C5 5.473 7.608 2.485 11 2"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17 6C15.8954 6 15 5.10457 15 4C15 2.89543 15.8954 2 17 2C18.1046 2 19 2.89543 19 4C19 5.10457 18.1046 6 17 6Z"
          stroke="#008CFF"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <div class="m-block">
      <div>Приближение</div>

      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.4193 8.2526C17.4193 4.70878 14.5464 1.83594 11.0026 1.83594C7.45878 1.83594 4.58594 4.70878 4.58594 8.2526V13.7526C4.58594 17.2964 7.45878 20.1693 11.0026 20.1693C14.5464 20.1693 17.4193 17.2964 17.4193 13.7526V8.2526Z"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11 5.5V9.16667"
          stroke="#008CFF"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</template>

<style lang="scss">
.mouse-control {
  background-color: #0e0e0f;
  border-style: solid;
  border-width: 2px;
  border-color: #18181a;

  box-sizing: border-box;

  height: 182px;
  width: 352px;

  padding: 16px;

  border-radius: 15px;

  .m-block {
    display: flex;
    justify-content: space-between;

    padding-top: 8px;
    padding-bottom: 8px;

    font-family: "Manrope";
    font-weight: 700;
    font-size: 16px;
    color: white;
  }

  .m-header {
    display: flex;
    align-items: center;

    color: #c7c7c7;

    font-family: "Manrope";
    font-size: 16px;
    font-weight: 700;

    .m-title {
      margin-left: 8px;
    }
  }
}
</style>

<script>
export default {
  name: "MouseControl",
};
</script>
